import { MasterSlaveEntry } from '@/data/hook/evaluation/useMasterSlaveMap';
import { findCloneByOrder } from '@/utils/evaluation/findCloneByOrder';
import { SlaveLessonBlocksRow } from '@/components/evaluation/AssessmentForm';

export const adaptAssessmentsLessonBlocks = (
  slaveEntries: MasterSlaveEntry[],
  assessmentOrder: number | undefined,
): SlaveLessonBlocksRow[] =>
  slaveEntries.map(({ slave }) => {
    const clone = !!assessmentOrder
      ? findCloneByOrder(slave.assessments, assessmentOrder)
      : undefined;
    return {
      slaveEvaluationId: slave.id,
      lessonBlockIds: clone?.lessonBlockIds ?? [],
    };
  });
